import { render, staticRenderFns } from "./LightLogin.vue?vue&type=template&id=35b49bbe&scoped=true&"
import script from "./LightLogin.vue?vue&type=script&lang=js&"
export * from "./LightLogin.vue?vue&type=script&lang=js&"
import style0 from "./LightLogin.vue?vue&type=style&index=0&id=35b49bbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b49bbe",
  null
  
)

export default component.exports